// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"345f315e","455":"d67ba464","977":"84e2506e"}[chunkId] + ".chunk.js";
};